var React = require('react');

function Category (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M166.78-140.78q-44.3 0-75.15-30.85-30.85-30.85-30.85-75.15v-466.44q0-44.87 30.85-75.43 30.85-30.57 75.15-30.57h224.74L480-730.74h313.22q44.87 0 75.43 30.85 30.57 30.85 30.57 75.15H436.26l-88.48-88.48h-181v469.26l93.74-300.78h694.74l-97.35 312.48q-14.78 45.78-46.17 68.63-31.39 22.85-78.31 22.85H166.78Zm112.83-106h471.35l59-191.96H338.61l-59 191.96Zm0 0 59-191.96-59 191.96ZM166.78-624.74v-88.48 88.48Z"}));
}

Category.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = Category;

Category.default = Category;
